import React from 'react';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import closeIcon from '../../assets/close-gray.svg';
import envelopeIcon from '../../assets/savedQuote/envelope.svg';

import { OPEN_SAVED_QUOTE_BREED_UNAVAILABLE_RESET } from '../../actions/types';
import { LANDING_URL } from '../../routes';

import ModalContainer from '../common/ModalContainer';

import './QuoteExpiredModal.css';

const QuoteExpiredModal = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation('quoting');
  const { saveQuote } = useSelector(({ quoting }) => quoting);

  const handleStartNewQuote = () => {
    const {
      Email,
      EmployerId,
      PetZipCode,
    } = saveQuote.breedUnavailableData || {};

    const search = queryString.stringify({
      email: Email || undefined,
      EmpId: EmployerId || undefined,
      petZipCode: PetZipCode || undefined,
    });

    dispatch({ type: OPEN_SAVED_QUOTE_BREED_UNAVAILABLE_RESET });

    history.push(
      search ? `${LANDING_URL}?${search}` : LANDING_URL,
      { fromBreedExpired: true },
    );
  };

  return (
    <ModalContainer
      cancelable={false}
      disableClickOutside
      handleOutClick={handleStartNewQuote}
      show={saveQuote.breedUnavailable}
    >
      <div className="Quote-expired-modal">
        <button
          aria-label="Close modal"
          className="Quote-expired-modal-close"
          onClick={handleStartNewQuote}
          type="button"
        >
          <img alt="" aria-hidden src={closeIcon} />
        </button>

        <div className="Quote-expired-modal-content">
          <img alt="" aria-hidden src={envelopeIcon} />

          <span className="Quote-expired-modal-title">
            {t('breedUnavailableModal.title')}
          </span>

          <p className="Quote-expired-modal-description">
            {t('breedUnavailableModal.description')}
          </p>
        </div>

        <button
          className="Quote-expired-modal-button"
          onClick={handleStartNewQuote}
          type="button"
        >
          {t('breedUnavailableModal.cta')}
        </button>
      </div>
    </ModalContainer>
  );
};

export { QuoteExpiredModal };
